var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8H10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11H8",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14H10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3462 3.34884C19.2769 3.34884 20.0385 2.59535 20.0385 1.67442C20.0385 0.753488 19.2769 0 18.3462 0C17.4154 0 16.6538 0.753488 16.6538 1.67442C16.6538 2.59535 17.4154 3.34884 18.3462 3.34884ZM15.2154 6.19535L12.8462 18H14.6231L16.1462 11.3023L17.9231 12.9767V18H19.6154V11.7209L17.8385 10.0465L18.3462 7.53488C19.4462 8.7907 21.1385 9.62791 23 9.62791V7.95349C21.3923 7.95349 20.0385 7.11628 19.3615 5.94419L18.5154 4.60465C18.1769 4.10233 17.6692 3.76744 17.0769 3.76744C16.8231 3.76744 16.6538 3.85116 16.4 3.85116L12 5.69302V9.62791H13.6923V6.7814L15.2154 6.19535Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestsWhite);
export default __webpack_public_path__ + "static/media/tests_white.3efbc2999ac040d932d98cf8e960e1e8.svg";
export { ForwardRef as ReactComponent };